<template>
  <div class="order_cnt" v-if="type!='history'">
    <div @click="countDown">
      <div class="op_minus"></div>
    </div>
    <input type="text" maxlength="2" v-model.number="count" @keypress="validateNumber" @input="count=inputRestNumber($event)" @blur="onBlurProductCount">
    <div @click="countUp">
      <div class="op_plus"></div>
    </div>
  </div>
  <div v-else>
    <span>商品個数 : {{count}}</span>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'

export default {
  name: 'DcCounter',
  components: {
  },
  props: {
    initCount: {
      type: Number,
      default: 0
    },
    type: String
  },
  data () {
    return {
      count: 0
    }
  },
  computed: {
  },
  methods: {
    getCount: function () {
      return Number(this.count)
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    onBlurProductCount: function () {
      if (!this.count || this.count <= 0) {
        this.count = 0
      }
    },
    countUp: function () {
      if (this.count < 99) {
        this.count++
      }
    },
    countDown: function () {
      this.count--
      if (this.count < 1) {
        this.count = 1
      }
    }
  },
  watch: {
    initCount: function (cnt) {
      this.count = cnt
    }
  },
  mounted: function () {
    this.count = this.initCount
  },
  created: function () {
  }
}
</script>
<style src="../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcCounter.vue